module.exports = __webpack_public_path__ + "static/img/international.256537bf.svg";